export interface ErrorReport {
  id: string;
  message: string;
  stack?: string;
  url: string;
  userAgent: string;
  timestamp: string;
}

class ErrorReporter {
  private queue: ErrorReport[] = [];
  private flushTimer: ReturnType<typeof setTimeout> | null = null;
  private maxQueue = 10;
  private flushInterval = 30000;

  capture(error: Error, _context?: Record<string, unknown>): void {
    const report: ErrorReport = {
      id: crypto?.randomUUID?.() ?? `${Date.now()}-${Math.random()}`,
      message: error.message,
      stack: error.stack,
      url: typeof window !== "undefined" ? window.location.href : "",
      userAgent: typeof navigator !== "undefined" ? navigator.userAgent : "",
      timestamp: new Date().toISOString(),
    };
    this.queue.push(report);
    this.scheduleFlush();

    if (this.queue.length >= this.maxQueue) {
      this.flush();
    }
  }

  private scheduleFlush(): void {
    if (this.flushTimer) return;
    this.flushTimer = setTimeout(() => {
      this.flushTimer = null;
      this.flush();
    }, this.flushInterval);
  }

  private async flush(): Promise<void> {
    if (this.flushTimer !== null) {
      clearTimeout(this.flushTimer);
      this.flushTimer = null;
    }
    if (this.queue.length === 0) return;
    const batch = this.queue.splice(0, this.maxQueue);

    try {
      // Degrade gracefully: if Supabase insert fails, log to console
      console.warn("[ErrorReporter] batch:", batch.length, "errors");
      // When Supabase client is available: await supabase.from('error_logs').insert(batch)
    } catch {
      // Silently fail in production
    }
  }
}

export const errorReporter = new ErrorReporter();
